<template>
  <v-col class="order-1 order-md-3">
    <v-dialog v-model="dialogCorte" max-width="700" persistent >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="success"
          elevation="2"
          outlined
          @click="calcularCorte()"
          :class="center ? 'escritorioCorte' : 'float-right escritorioCorte' "
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left> mdi-cash-register </v-icon>
          Corte de caja
        </v-btn>
      </template>

      <v-card>
        <div :class=" paso != 3 ? 'absolute' : 'fix'" v-if="loading">
      <Spinner :clase=" paso != 3 ? true : false"/>
    </div>
        <v-card-title
          v-show="paso != 3"
          class="text-h6 text-weingth-bold white lighten-2 text-primary"
        >
          Corte de caja
        </v-card-title>
        <div v-if="paso == 1">
          <v-card-subtitle
            >Por favor, cuenta el dinero y vouchers en caja e ingrésalo para
            proceder con el cierre de turno.</v-card-subtitle
          >
          <div class="d-flex ml-5 mr-5">
            <span><b>Usuario:</b> {{ sesion?.name }}</span>
            <v-spacer></v-spacer>
          </div>
          <div class="d-flex mt-3 ml-5 mr-5">
            <span><b>Fecha Inicio:</b> {{ arqueo.horaInicio }}</span>
            <v-spacer></v-spacer>
            <span v-if="arqueo"
              ><b>Fecha Fin:</b>  
              {{ arqueo.horaFinal }}</span
            >
          </div>

          <div class="cajas">
            <div class="cabeza">Caja</div>
            <div class="cuerpo caja">
              <v-row>
                <v-col>
                  <p>Arqueo</p>
                </v-col>
                <v-col>
                  <p v-if="arqueo">${{ arqueo.inBoxStart?.toFixed(2) }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Efectivo actual en caja</p>
                </v-col>
                <v-col>
                  <v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/efectivo verde.svg"
                    height="30px"
                  ></v-img>
                  <v-text-field
                    v-model="efectivoCorte"
                    placeholder="$0.00"
                    outlined
                    min="0"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Pago con tarjeta</p>
                </v-col>
                <v-col>
                  <v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/tarjeta debito verde.svg"
                    height="30px"
                  ></v-img>
                  <v-text-field
                    v-model="tarjetaCorte"
                    placeholder="$0.00"
                    outlined
                    min="0"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Transferencias</p>
                </v-col>
                <v-col>
                  <v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/calculadora icon.svg"
                    height="30px"
                  ></v-img>
                  <v-text-field
                    v-model="transferenciaCorte"
                    placeholder="$0.00"
                    outlined
                    min="0"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div v-else-if="paso == 2">
          <div class="cajas">
            <div class="cabeza d-flex">
              <span><b>Usuario:</b> {{ sesion?.name }}</span>
              <v-spacer></v-spacer>
              <span v-if="arqueo"
                ><b>Hora:</b> {{ arqueo.horaInicio }} a
                {{ arqueo.horaFinal }}</span
              >
            </div>
            <div class="cuerpo caja">
              <v-row>
                <v-col style="background-color: #fafafa"></v-col>
                <v-col><b>GENERADO</b></v-col>
                <v-col><b>INGRESADO</b></v-col>
                <v-col><b>DIFERENCIA</b></v-col>
              </v-row>
              <v-row>
                <v-col
                  style="background-color: #fafafa"
                  class="d-flex flex-column"
                  ><v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/efectivo verde.svg"
                    height="30px"
                  ></v-img
                  ><span>Pago en efectivo</span></v-col
                >
                <v-col>${{ arqueo.efective?.toFixed(2) }}</v-col>
                <v-col
                  >${{
                    (parseFloat(efectivoCorte) - arqueo.inBoxStart)?.toFixed(2)
                  }}</v-col
                >
                <v-col
                  :class="{
                    'text-verde':
                      parseFloat(efectivoCorte) -
                        arqueo.inBoxStart?.toFixed(2) -
                        arqueo.efective >=
                      0,
                    'text-rojo':
                      parseFloat(efectivoCorte) -
                        arqueo.inBoxStart?.toFixed(2) -
                        arqueo.efective <
                      0,
                  }"
                  >${{
                    (
                      parseFloat(efectivoCorte) -
                      arqueo.inBoxStart?.toFixed(2) -
                      arqueo.efective
                    )?.toFixed(2)
                  }}</v-col
                >
              </v-row>
              <v-row>
                <v-col
                  style="background-color: #fafafa"
                  class="d-flex flex-column"
                  ><v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/tarjeta debito verde.svg"
                    height="30px"
                  ></v-img
                  ><span>Pago con tarjeta</span></v-col
                >
                <v-col>${{ arqueo.creditCard?.toFixed(2) }}</v-col>
                <v-col>${{ parseFloat(tarjetaCorte)?.toFixed(2) }}</v-col>
                <v-col
                  :class="{
                    'text-verde':
                      parseFloat(tarjetaCorte) - arqueo.creditCard >= 0,
                    'text-rojo':
                      parseFloat(tarjetaCorte) - arqueo.creditCard < 0,
                  }"
                  >${{
                    (parseFloat(tarjetaCorte) - arqueo.creditCard)?.toFixed(2)
                  }}</v-col
                >
              </v-row>
              <v-row>
                <v-col
                  style="background-color: #fafafa"
                  class="d-flex flex-column"
                  ><v-img
                    contain
                    class="mt-1 mr-1"
                    src="@/assets/imgs/puntoVenta/calculadora icon.svg"
                    height="30px"
                  ></v-img
                  ><span>Transferencias</span></v-col
                >
                <v-col>${{ arqueo.transfer?.toFixed(2) }}</v-col>
                <v-col>${{ parseFloat(transferenciaCorte)?.toFixed(2) }}</v-col>
                <v-col
                  :class="{
                    'text-verde':
                      parseFloat(transferenciaCorte) - arqueo.transfer >= 0,
                    'text-rojo':
                      parseFloat(transferenciaCorte) - arqueo.transfer < 0,
                  }"
                  >${{
                    (parseFloat(transferenciaCorte) - arqueo.transfer)?.toFixed(
                      2
                    )
                  }}</v-col
                >
              </v-row>
            </div>
          </div>
          <div class="d-flex justify-center mb-5">
            <div class="box mr-4">
              Arqueo: ${{ arqueo.inBoxStart?.toFixed(2) }}
            </div>
            <div class="box">
              <b>Total ventas ${{ arqueo.totalSale?.toFixed(2) }}</b>
            </div>
          </div>
        </div>
        <div v-else class="d-flex flex-column mt-5 mb-3 ">
          <v-img
            contain
            class="mt-15 mb-3"
            src="@/assets/imgs/puntoVenta/abrir caja icon.svg"
            height="114px"
          ></v-img>
          <h4 class="text-center"><b>¿Está seguro de realizar el corte de caja?</b></h4>
          <span class="text-center">Una vez hecho, no se podrán hacer cambios.</span>
        </div>
        <v-card-actions>
          <div class="d-flex w-100 justify-center">
            <v-btn
              color="success"
              text
              @click="paso == 1 ? closeDialog() : (paso = paso - 1)"
            >
              {{ paso == 3 ? "No, regresar y verificar" : "Cancelar" }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="
                efectivoCorte == '' ||
                tarjetaCorte == '' ||
                transferenciaCorte == '' ||
                loading
              "
              @click="paso == 3 ? registrarCorte() : (paso = paso + 1)"
            >
              {{ paso == 3 ? "Si, hacer corte de caja" : "Continuar" }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import Spinner from "../Loaders/spinner.vue";
import ApiService from "../../services/apis";
import Swal from "sweetalert2";
import moment from "moment"
export default {
  name: "CierreCaja",
  components:{
    Spinner
  },
  props: {
    sesion:{
      require:true
    },
    center:{
      type:Boolean,
      default:false
    }
  },
  emits:["closeDialog"],
  data() {
    return {
        paso:1,
        dialogCorte:false,
        arqueo:[],
        transferenciaCorte:'0',
        efectivoCorte:'0',
      tarjetaCorte:'0',
      loading:false
    };
  },
  created(){
    this.calcularCorte()
  },
  methods: {
    clearCut(){
      this.transferenciaCorte ='0'
        this.efectivoCorte ='0'
      this.tarjetaCorte ='0'
    },
    async calcularCorte(){
      try{
      this.loading = true
      this.paso=1
      let caja={
        saleBoxId:0,
        user:this.sesion._id
        }
      const res = await ApiService.calcularCaja(caja)
      this.loading = false
        this.arqueo=res.data
        this.arqueo.horaInicio=moment(res?.data?.initDate || res?.data?.cretedAt).format('DD/MM/YYYY h:mm a')
        this.arqueo.horaFinal=moment().format('DD/MM/YYYY h:mm a')
      }catch(err){
        this.loading = false
        return err
      }
    },
    async registrarCorte(){
      try{
      this.loading = true
      let registrar={
        saleBoxId:0,
        user:this.sesion._id,
        boxCutCash:parseFloat(((parseFloat(this.efectivoCorte)-this.arqueo.inBoxStart)-this.arqueo.efective)?.toFixed(2)),
        boxCutOthers:(parseFloat(this.tarjetaCorte)-this.arqueo.creditCard)+(parseFloat(this.transferenciaCorte)-this.arqueo.transfer),
        boxCutResult:parseFloat(((parseFloat(this.tarjetaCorte)-this.arqueo.creditCard)+(parseFloat(this.transferenciaCorte)-this.arqueo.transfer)+((parseFloat(this.efectivoCorte)-this.arqueo.inBoxStart)-this.arqueo.efective))?.toFixed(2))
      }
      await ApiService.registrarCorte(registrar)
      this.clearCut()
       Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Corte registrado con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.loading = false
        this.$emit("cerrarCorte",0)
        this.dialogCorte=false
      }catch(err){
        this.loading = false
        return err
      }
    },
    closeDialog(){
      this.clearCut()
        this.dialogCorte = false
    }
  },
};
</script>

<style scoped>


.absolute {
  position: relative;
  top:0;
  left: 0;
  z-index: 600;
}

.fix{
position: fixed;
top: 45%;
left: 47%;
}


.sale-container{
  max-height: 350px;
  overflow: scroll;
  cursor: all-scroll;
}

.check-container{
  display: flex;
  align-items: center;
}



.check{
  height: 15px;
  width: 15px;
  cursor: pointer;
  color: #ccc;
}

.check-co{
  order: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 35px;
  height: 35px;
}

.label{
  order: 2;
  cursor: pointer;
  padding: 5px;
  padding-left: 2px;
}
.check-co:hover{
  background-color: #ccc;
}
.check:hover{
min-width: 100px;
}
.delete-item{
  color: #EA1F1F;
  height: 30px;
  width: 30px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;

  background-color: rgba(0, 0, 0, .1);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.text-center{
  text-align: center;
}

.cajas{
  border-radius: 4px;
  border-color: #F3F3F3;
  margin: 15px;
  box-shadow: 0px 3px 6px #00000029;

}
.cabeza{
  border-radius: 4px 4px 0 0;
  background-color: #F3F3F3;
  padding: 8px
}
.cuerpo{
  display: flex;
  flex-direction: row;
  border-radius: 0 0 4px 4px;
  border-color: #F3F3F3;
  justify-content: flex-start;
    align-items: center;
    padding: 15px;
}
.cuerpo.caja{
  flex-direction: column;
}
.cuerpo .row{
  width: 100%;
}
.cuerpo div{
  display: flex;
  flex-direction: row;
}

.box{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  padding: 10px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-h6{
  color: #0A4F9C;
  font-weight: bold!important;
  font-size: 20px!important;
}
.v-card__subtitle{
  text-align: left;
  margin-top: 5px;
}
.centro{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 40%;
  position: relative;
}
.completo{
  height: 80vh;
}
.punteado{
  box-shadow: 0px 3px 6px #00000029;
  border: 1px dashed #AFAFAF;
  border-radius: 4px;
  padding: 1.2rem;
}
.punteado hr{
  border: 1px dashed #AFAFAF;
  border-radius: 4px;
}
.botonVentas{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #AFAFAF;
  border-radius: 4px;
  color: #AFAFAF;
  width: 140px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 7px;
  cursor: pointer;
}
.botonVentas.activo{
  background-color: #EDF6FD;
  border-color:#0A4F9C;
  color:#0A4F9C;
}

.botonVentas:hover{
  background-color: #EDF6FD;
  border-color:#0A4F9C;
  color:#0A4F9C;
}
.text-verde{
  color:#4CAF50
}
.text-rojo{
  color: #EA1F1F;
}
</style>
